import { VFlow } from 'bold-ui'
import { resolveName } from 'components/form'
import { DEFAULT_SELECT_SIZE } from 'components/form/field/select/useAsyncQuerySelect'
import { ProcedimentoSelect } from 'components/select/ProcedimentoSelect/ProcedimentoSelect'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { useFieldArray } from 'react-final-form-arrays'
import { dateAsYyyyMmDd, toDate } from 'util/date/formatDate'
import { MetaRoot } from 'util/metaPath'

import { AppendItemExames } from '../../../../plano/exames/components/AppendItemExames'
import {
  ANEXO_ARQUIVOS_GRUPOS_PROCEDIMENTO,
  ANEXO_ARQUIVOS_SUBGRUPOS_PROCEDIMENTO,
  AnexoArquivoFormModel,
  ResultadoExameAnexoFormModel,
} from '../../model-anexoArquivos'
import { ExameAccordion } from './ExameAccordion'

interface ExamesNaoSolicitadosFormProps {
  name: MetaRoot<AnexoArquivoFormModel>
}

export function ExamesNaoSolicitadosForm(props: Readonly<ExamesNaoSolicitadosFormProps>) {
  const { name } = props

  const {
    fields: { push, remove, value },
  } = useFieldArray(resolveName(name.resultadosSemSolicitacao), { subscription: { value: true } })

  const {
    cidadao: { sexo, identidadeGeneroDbEnum, dataNascimento },
    atendimentoProfissional: { iniciadoEm },
  } = useAtendimentoContext()

  return (
    <VFlow>
      <ProcedimentoSelect
        loadItemsOnOpen
        dataAtendimento={dateAsYyyyMmDd(iniciadoEm)}
        gruposProcedimento={ANEXO_ARQUIVOS_GRUPOS_PROCEDIMENTO}
        subGruposProcedimento={ANEXO_ARQUIVOS_SUBGRUPOS_PROCEDIMENTO}
        sexo={sexo}
        identidadeGeneroDbEnum={identidadeGeneroDbEnum}
        placeholder='Busque por exame para inserir o resultado'
        components={{
          AppendItem: ({ items }) => AppendItemExames(items?.length, DEFAULT_SELECT_SIZE),
        }}
        onChange={(item) => push(item as ResultadoExameAnexoFormModel)}
      />

      {value?.filterNotNull().map((item, idx) => {
        const { dataSolicitacao, dataRealizado } = item
        const dataRealizadoAsDate = toDate(dataRealizado)
        const dataSolicitadoAsDate = toDate(dataSolicitacao)

        return (
          <ExameAccordion
            key={item.id}
            name={name.resultadosSemSolicitacao?.[idx]}
            remove={() => remove(idx)}
            value={item}
            dataInicioAtendimento={iniciadoEm}
            dataRealizado={dataRealizadoAsDate}
            dataSolicitado={dataSolicitadoAsDate}
            dataNascimento={toDate(dataNascimento)}
            isSolicitado={false}
          />
        )
      })}
    </VFlow>
  )
}
